// extracted by mini-css-extract-plugin
export var breadcrumb = "_y-0";
export var breadcrumbArrow = "_y-1";